export const companyArabicName =
  "وحدة تقييم الأصول العقارية — شركة كيان الاستشارات الهندسية";

export const companyLegalNameAr = "شركة كيان الاستشارات الهندسية";

export const valuationUnitNameAr = "وحدة تقييم الأصول العقارية";

export const serviceDisclaimer =
  "هذه الخدمة لا تمثل تقييماً للقيمة السوقية للعقار، وإنما تقتصر على التقييم الهندسي للحالة الفنية والأضرار وتكلفة الإصلاح ضمن نطاق العمل المحدد.";

export const reportDisclaimer =
  "هذا التقرير لا يمثل تقديراً للقيمة السوقية للعقار، وإنما يقتصر على التقييم الهندسي للحالة الفنية والأضرار وتكلفة الإصلاح ضمن نطاق العمل المحدد.";

export const positioningPhrase = "تقييم هندسي يعتمد عليه في القرار";

export const launchCities = ["الرياض", "جدة", "الدمام", "الخبر"] as const;

export const organizationTypes = [
  "بنك",
  "شركة تمويل",
  "شركة تأمين",
  "مطور عقاري",
  "مالك محفظة",
  "أخرى",
] as const;

export const requestPurposes = [
  "تقييم أضرار",
  "تقييم حالة فنية",
  "تقدير تكلفة إصلاح",
  "تقرير تأميني",
  "تقرير لجهة تمويل",
  "إدارة أو إشراف ترميم",
  "أخرى",
] as const;

export const requestStatuses = [
  "new",
  "under_review",
  "waiting_for_more_information",
  "quotation_in_progress",
  "quotation_issued",
  "quotation_accepted",
  "work_order_issued",
  "inspection_scheduled",
  "inspected",
  "report_in_progress",
  "internal_review",
  "report_approved",
  "invoice_data_ready",
  "closed",
  "cancelled",
] as const;

export type RequestStatus = (typeof requestStatuses)[number];

export const statusLabels: Record<RequestStatus, string> = {
  new: "جديد",
  under_review: "قيد المراجعة",
  waiting_for_more_information: "بانتظار معلومات إضافية",
  quotation_in_progress: "عرض السعر قيد الإعداد",
  quotation_issued: "تم إصدار عرض السعر",
  quotation_accepted: "تم قبول عرض السعر",
  work_order_issued: "تم إصدار أمر العمل",
  inspection_scheduled: "تم جدولة المعاينة",
  inspected: "تمت المعاينة",
  report_in_progress: "التقرير قيد الإعداد",
  internal_review: "مراجعة داخلية",
  report_approved: "تم اعتماد التقرير",
  invoice_data_ready: "بيانات الفاتورة جاهزة",
  closed: "مغلق",
  cancelled: "ملغي",
};

export const services = [
  {
    title: "التقييم الهندسي لغرض التمويل والتأمين",
    description:
      "رأي هندسي مستقل يساعد الجهات التمويلية والتأمينية على فهم الحالة الفنية ونطاق المخاطر.",
  },
  {
    title: "تقييم الأضرار والحالة الفنية",
    description:
      "معاينة ميدانية وتشخيص فني للأضرار الظاهرة والمؤثرة على الأصل العقاري.",
  },
  {
    title: "تقدير تكلفة الإصلاح",
    description:
      "تسعير موثق لنطاق الإصلاح المقترح بالاستناد إلى بيانات سوق محققة ضمن نطاق العمل.",
  },
  {
    title: "الفحص الفني قبل التمويل أو الشراء",
    description:
      "فحص فني يدعم قرار الجهة الطالبة قبل التمويل أو الاستحواذ أو اتخاذ قرار استثماري.",
  },
  {
    title: "التقرير الفني والتقرير التأميني",
    description:
      "قوالب تقارير واضحة قابلة للطباعة وتتضمن المنهجية، الأدلة، النتائج، والتوصيات.",
  },
  {
    title: "إدارة وإشراف أعمال الإصلاح والترميم",
    description:
      "دعم لاحق للتقرير عبر إدارة أو إشراف أعمال الإصلاح من شركة كيان أو شركاء مؤهلين.",
  },
  {
    title: "المسوحات الدورية لمحافظ الأصول",
    description:
      "زيارات دورية لمحافظ عقارية لمتابعة الحالة الفنية وتحديث أولويات التدخل.",
  },
  {
    title: "آراء هندسية متخصصة",
    description:
      "رأي هندسي محدد عند وجود ضرر أو نزاع أو حاجة لتحديد نطاق إصلاح فني.",
  },
];

export const methodologySteps = [
  {
    title: "الاستلام وتحديد النطاق",
    description: "تحديد الجهة الطالبة، الغرض، المستندات، وحدود العمل الفني.",
  },
  {
    title: "المعاينة الميدانية وجمع الأدلة",
    description: "توثيق الحالة الفنية والأضرار والملاحظات المرتبطة بالأصل.",
  },
  {
    title: "التحليل الفني",
    description: "تحليل السبب المحتمل، مستوى الخطورة، وأثر الضرر على الاستخدام.",
  },
  {
    title: "التسعير وفق سوق محققة",
    description: "تقدير تكلفة الإصلاح بناء على نطاق موثق وأسعار قابلة للمراجعة.",
  },
  {
    title: "إصدار التقريرين",
    description: "إعداد التقرير الفني أو التأميني والملخص التنفيذي عند الحاجة.",
  },
  {
    title: "الدعم اللاحق وإدارة التنفيذ",
    description:
      "دعم الجهة الطالبة بعد التقرير أو إدارة أعمال الإصلاح والترميم ضمن اتفاق مستقل.",
  },
];

export const reportTemplates = [
  {
    title: "التقرير الفني الهندسي",
    description:
      "يوثق بيانات الجهة الطالبة والعقار، نطاق العمل، منهجية المعاينة، جدول الأضرار، التحليل الفني، تكلفة الإصلاح، والتوصيات.",
  },
  {
    title: "التقرير التأميني",
    description:
      "يركز على الضرر محل الفحص، الأدلة، السبب الفني المحتمل، نطاق الإصلاح، التكلفة التقديرية، وملاحظات شركة التأمين.",
  },
  {
    title: "الملخص التنفيذي",
    description:
      "نسخة مركزة تتضمن رقم الطلب، الجهة الطالبة، الغرض، خلاصة الحالة الفنية، مستوى الخطورة، والتوصية المقترحة.",
  },
];

export const leadership = [
  {
    name: "أ. إدريس البديري",
    title: "مدير وحدة تقييم الأصول العقارية",
  },
  {
    name: "د. صخر بن طلال الأمير",
    title: "المدير التنفيذي، شركة كيان الاستشارات الهندسية",
  },
];

export const navigation = [
  { label: "الرئيسية", href: "/" },
  { label: "وحدة التقييم", href: "/valuation-unit" },
  { label: "الخدمات", href: "/services" },
  { label: "المنهجية", href: "/methodology" },
  { label: "التقارير", href: "/reports" },
  { label: "التغطية", href: "/coverage" },
  { label: "القيادة", href: "/leadership" },
  { label: "تواصل", href: "/contact" },
];
